import api from './api';

export const addPdfReportApi = params => api.post('/report', params);
export const getPdfReportsApi = params => api.get('/report', {params});
export const getPdfPayloadByIdApi = id => api.get(`/report/${id}/payload`);
export const getPdfReportsByNameApi = (elevatorName, params) => api.get(`/report/elevator/name/${elevatorName}`, {params});
export const sendPdfByMailApi = (formData) => {
    const reportId = formData.get('reportId');
    return api.post(`/report/${reportId}/send-email`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',  
      }
    });
  };
